import React, { useState, useEffect, useRef } from 'react';
import * as THREE from 'three';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import './LoadingAnimation.css';
import Rocket from './rocket.js'; // Import your Rocket component

const SpaceLoading = ({ children, key }) => {
  const [isLoading, setIsLoading] = useState(true);
  const canvasRef = useRef(null);
  const location = useLocation();
  const landingElementRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);

    if (canvasRef.current) {
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      const renderer = new THREE.WebGLRenderer({ canvas: canvasRef.current, alpha: true });
      renderer.setSize(window.innerWidth, window.innerHeight);

      camera.position.z = 5;

      // Stars
      const starsGeometry = new THREE.BufferGeometry();
      const starsMaterial = new THREE.PointsMaterial({ color: 0xffffff, size: 5 });
      const starsVertices = [];
      for (let i = 0; i < 1000; i++) {
        const x = (Math.random() - 0.5) * 2000;
        const y = (Math.random() - 0.5) * 2000;
        const z = -Math.random() * 1000;
        starsVertices.push(x, y, z);
      }
      starsGeometry.setAttribute('position', new THREE.Float32BufferAttribute(starsVertices, 3));
      const stars = new THREE.Points(starsGeometry, starsMaterial);
      scene.add(stars);

      // Planet
      const planetGeometry = new THREE.SphereGeometry(1, 32, 32);
      const planetMaterial = new THREE.MeshBasicMaterial({ color: 0x0088ff, wireframe: true });
      const planet = new THREE.Mesh(planetGeometry, planetMaterial);
      scene.add(planet);

      const ambientLight = new THREE.AmbientLight(0x404040); // Soft white light
      scene.add(ambientLight);

      const pointLight = new THREE.PointLight(0xffffff, 400); // White light, intensity 1
      pointLight.position.set(0,0,10); // Position the light
      scene.add(pointLight);

      // Landing Element (Rocket)
      const rocket = new Rocket(); // Instantiate Rocket
      rocket.mesh.position.y = 5; // Start off-screen
      rocket.mesh.scale.set(0.003, 0.003, 0.003);
      scene.add(rocket.mesh); // Add Rocket's mesh to the scene
      landingElementRef.current = rocket.mesh; // Set ref to Rocket's mesh

      const animate = () => {
        requestAnimationFrame(animate);
        planet.rotation.x += 0.005;
        planet.rotation.y += 0.005;
        stars.position.z += 0.5;
        if (stars.position.z > 0) {
          stars.position.z = -1000;
        }
        renderer.render(scene, camera);
      };
      animate();

      return () => {
        renderer.dispose();
      };
    }
  }, [location.pathname]);

  useEffect(() => {
    if (landingElementRef.current) {
      gsap.killTweensOf(landingElementRef.current.position);
      gsap.to(landingElementRef.current.position, {
        y: 0.5,
        duration: 2,
        ease: 'power2.inOut',
        onComplete: () => {
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
        },
      });
    }
  }, [location.pathname]);

  return isLoading ? (
    <div className="space-loading">
      <canvas ref={canvasRef} className="space-canvas" />
      <div className="loading-text">Landing...</div>
    </div>
  ) : (
    <>{children}</>
  );
};

export default SpaceLoading;